(() => {

    // mock data
    let data = [
        { label: 'Bluewater Park, QLD', value: '4818', id: '5' },
        { label: 'Brisbane Market, QLD', value: '4106', id: '4' },
        { label: 'The Limits, QLD', value: '4625', id: '3' },
        { label: 'South Nanango, QLD', value: '4615', id: '2' },
        { label: 'Sydney, NSW', value: '2000', id: '1' },
    ]; // label and value are compulsory

    let typeaheadInput = document.querySelector("typeahead-input#typeaheadResidenceSuburb");

    if (typeaheadInput) {
        typeaheadInput.doDataFetch = onDataFetch;
        typeaheadInput.addEventListener('select', onSelect);
    }

    // This function will be triggered when user type in the input
    /**
    * @param {string} text  User input.
    * @param {func} callback Callback function must be called when suggested data is prepared.
    */
    function onDataFetch(text, callback) {
        text = text.toLowerCase();

        // make ajax call to fetch suggestions from server
        const suggestions = data;

        // callback
        callback(suggestions);
    }

    // This function will be triggered when user select a suggestion
    /**
    */
    function onSelect({ detail }) {
        const hiddenInput = document.querySelector<HTMLInputElement>("#txtCurrentSuburbId");

        if (hiddenInput) {
            if (detail) {
                hiddenInput.value = detail.id;
            } else {
                hiddenInput.value = '';
            }
        }
    }
})();
